export interface BlogSection {
  heading: string;
  body: string;
  image?: string;
}

export interface BlogPost {
  id: number;
  category: string;
  title: string;
  excerpt: string;
  readTime: string;
  date: string;
  image: string;
  tags: string[];
  featured: boolean;
  content: BlogSection[];
}

export const blogPosts: BlogPost[] = [
  {
    id: 1,
    category: "熟齡穿搭",
    title: "熟齡女性穿搭指南｜如何穿出優雅自信的都會風格",
    excerpt: "許多熟齡女性在穿搭上常感到困惑——既不想太過保守，又擔心穿得太年輕不適合。其實，熟齡女性最大的穿搭優勢就是獨特的氣質與品味，掌握幾個關鍵技巧，就能輕鬆穿出屬於自己的優雅風範。",
    readTime: "5 分鐘",
    date: "2024-04-10",
    image: "https://readdy.ai/api/search-image?query=elegant%20mature%20taiwanese%20woman%2050s%20graceful%20urban%20outfit%20sophisticated%20style%20warm%20cream%20beige%20background%20designer%20fashion%20quality%20editorial%20photography&width=1200&height=640&seq=blog001&orientation=landscape",
    tags: ["熟齡穿搭", "優雅", "都會風格"],
    featured: true,
    content: [
      {
        heading: "了解自己的優勢，是穿搭的第一步",
        body: "熟齡女性最大的魅力在於從容的氣質與對自己的深刻了解。穿搭的第一步，是認識自己的身材優勢，並選擇能強調這些優點的款式。修身版型能展現身材輪廓，而適度的寬鬆則能帶來飄逸的優雅感。不需要遮掩，而是要懂得「展示」。",
        image: "https://readdy.ai/api/search-image?query=elegant%20mature%20taiwanese%20woman%20confident%20self-aware%20fashion%20styling%20warm%20neutral%20cream%20background%20designer%20quality%20graceful%20posture%20editorial%20photography&width=800&height=500&seq=blog001a&orientation=landscape"
      },
      {
        heading: "顏色搭配的智慧：選對色系，氣質自然來",
        body: "熟齡女性特別適合低彩度的優雅色系，如奶油白、米杏色、霧灰色和乾燥玫瑰色。這些顏色不只顯氣質，更能與肌膚色調和諧搭配，呈現出成熟女性特有的柔和光澤。建議以兩種相近色調做主角，再以一個深色或金色調作為點綴，整體造型自然有層次。",
      },
      {
        heading: "版型選擇的關鍵：修身但不束縛",
        body: "在版型上，建議選擇有結構感但不過於緊繃的款式。A 字裙與傘裙能修飾腰腹，寬管褲則能拉長腿部比例。上衣選擇略有腰線設計的款式，能在展示身材比例的同時，保持舒適感。避免過於寬大的版型，那往往會讓人看起來更臃腫而非顯瘦。",
        image: "https://readdy.ai/api/search-image?query=elegant%20mature%20women%20fashion%20outfit%20comparison%20tailored%20versus%20oversized%20warm%20neutral%20background%20taiwanese%20designer%20quality%20fabric%20silhouette%20editorial&width=800&height=500&seq=blog001b&orientation=landscape"
      },
      {
        heading: "配件畫龍點睛：少即是多的精緻原則",
        body: "簡單的服飾搭配精緻的配件，是熟齡女性穿搭的最高境界。一條質感圍巾、一只優雅手錶，或是精心挑選的絲巾，都能讓整體造型提升到另一個層次。建議選擇金色或玫瑰金的金屬飾品，與整體暖色調相呼應，展現低調的奢華質感。",
      },
      {
        heading: "實穿推薦：值得投資的經典單品",
        body: "如果要為熟齡女性推薦幾件必備單品，首選是一件剪裁精良的西裝外套、一條修身的直筒長褲、一件有腰線設計的洋裝，以及一件質感針織上衣。這四件單品相互搭配，可以變化出超過十種造型，應付各種場合都不在話下。",
      }
    ],
  },
  {
    id: 2,
    category: "顯瘦技巧",
    title: "顯瘦穿搭秘訣｜5 個讓你看起來更纖細的穿搭技巧",
    excerpt: "想要在視覺上顯得更纖細，其實有很多聰明的穿搭技巧可以運用。從顏色、剪裁到層次搭配，每一個細節都能幫助你打造更完美的身材比例，輕鬆穿出理想中的纖細感。",
    readTime: "4 分鐘",
    date: "2024-04-05",
    image: "https://readdy.ai/api/search-image?query=elegant%20taiwanese%20woman%20slimming%20fashion%20outfit%20vertical%20line%20design%20graceful%20silhouette%20cream%20neutral%20background%20designer%20quality%20fashion%20editorial&width=1200&height=640&seq=blog002&orientation=landscape",
    tags: ["顯瘦穿搭", "修飾版型", "穿搭技巧"],
    featured: true,
    content: [
      {
        heading: "技巧一：善用垂直線條，視覺延伸效果立竿見影",
        body: "垂直線條是最簡單有效的顯瘦工具。選擇有縱向拼接、V 領設計、或垂直條紋的服飾，能將視線引導上下延伸，讓身形看起來更為修長。連身裙搭配腰帶束腰，也是創造垂直視覺效果的好方法。",
        image: "https://readdy.ai/api/search-image?query=elegant%20women%20vertical%20line%20fashion%20design%20v-neck%20dress%20graceful%20slimming%20silhouette%20warm%20cream%20background%20taiwanese%20designer%20quality%20editorial%20photography&width=800&height=500&seq=blog002a&orientation=landscape"
      },
      {
        heading: "技巧二：高腰設計，輕鬆拉長下半身比例",
        body: "高腰款式是顯瘦顯高的神器。高腰長褲或高腰裙能將腰線視覺上移，讓腿部比例顯得更長。搭配塞進去的上衣或短版上衣，效果更為明顯。這個技巧對各種身材都有效，是值得投資的版型方向。",
      },
      {
        heading: "技巧三：選對面料，垂墜感是關鍵",
        body: "面料的選擇直接影響顯瘦效果。垂墜感好的雪紡、絲質或輕盈針織，能自然隨身體曲線流動，既不強調又不隱藏，展現出最自然的身材輪廓。避免過於硬挺或過於厚重的面料，這些往往會讓身形看起來更為膨脹。",
        image: "https://readdy.ai/api/search-image?query=women%20chiffon%20draped%20fabric%20fashion%20flowing%20graceful%20slimming%20silhouette%20warm%20neutral%20background%20taiwanese%20designer%20quality%20editorial%20style%20photography&width=800&height=500&seq=blog002b&orientation=landscape"
      },
      {
        heading: "技巧四：顏色的深淺搭配，創造視覺焦點",
        body: "深色的視覺後退效果人人皆知，但並非所有情況都要穿深色。更聰明的做法是利用深淺對比，將視覺焦點引導到你想強調的部位。例如深色下身搭配淺色上身，能讓腰部以上更為突出；或是整身同色調，製造一氣呵成的修長感。",
      },
      {
        heading: "技巧五：合身剪裁，讓每一寸都恰到好處",
        body: "過大或過小的衣服都無法顯瘦。合身的剪裁才能讓布料在對的地方貼合，在需要空間的地方留有餘裕，整體呈現出最完美的身材比例。建議在購買前一定要試穿，或參考尺寸對照表仔細確認，投資一件合身的衣服遠比買十件勉強合適的更有價值。",
      }
    ],
  },
  {
    id: 3,
    category: "洋裝挑選",
    title: "洋裝怎麼挑才修飾？各種身材適合的洋裝版型解析",
    excerpt: "洋裝是女性衣櫥中最百搭、最能展現女性氣質的單品。但面對琳琅滿目的款式，如何挑選最適合自己身材的洋裝，一直是許多女性的困擾。這篇文章帶你系統了解各種版型的適合對象。",
    readTime: "6 分鐘",
    date: "2024-03-30",
    image: "https://public.readdy.ai/ai/img_res/edited_606559a081314e47c18f4194b6fd7e3f_09bbdcea.jpg",
    tags: ["洋裝", "版型", "修飾"],
    featured: false,
    content: [
      {
        heading: "A 字裙型洋裝：最萬用的修飾版型",
        body: "A 字型洋裝從腰部往下漸寬展開，是最能修飾梨形身材的版型。腰部合身的設計能強調腰線，而下擺的寬鬆則能遮掩臀部與大腿。幾乎所有身材都適合 A 字型洋裝，是衣橱中不可或缺的基本款。",
        image: "https://readdy.ai/api/search-image?query=elegant%20women%20A-line%20dress%20fit%20flare%20silhouette%20mature%20taiwanese%20designer%20quality%20fabric%20warm%20cream%20background%20fashion%20editorial%20graceful%20photography&width=800&height=500&seq=blog003a&orientation=landscape"
      },
      {
        heading: "直筒型洋裝：展現從容的都會氣質",
        body: "直筒型洋裝線條簡潔，從肩膀到裙擺幾乎同寬，展現出一種不強調曲線的從容美感。這個版型特別適合身形較為均勻或上半身較豐腴的女性，搭配腰帶可以製造腰線，更為靈活多變。",
      },
      {
        heading: "包裹型洋裝：強調腰線的優雅選擇",
        body: "包裹型洋裝（Wrap Dress）通過交叉綁帶自然強調腰部曲線，同時 V 領設計修飾臉型與頸部。這個版型特別受熟齡女性歡迎，既有優雅感又不失舒適，非常適合聚餐、下午茶等半正式場合。",
        image: "https://readdy.ai/api/search-image?query=elegant%20women%20wrap%20dress%20v-neck%20waist%20tie%20silhouette%20mature%20taiwanese%20designer%20quality%20fabric%20warm%20dusty%20rose%20background%20fashion%20editorial%20photography&width=800&height=500&seq=blog003b&orientation=landscape"
      },
      {
        heading: "Midi 長度：最優雅的裙擺長度",
        body: "Midi 長度（膝下到小腿中段）是最能展現優雅氣質的裙擺長度，也最適合熟齡女性。這個長度能遮掩腿部不夠纖細的問題，同時搭配中低跟鞋時，整體比例非常協調。建議選擇裙擺不過於寬鬆的版型，以維持整體的俐落感。",
      }
    ],
  },
  {
    id: 4,
    category: "上班穿搭",
    title: "上班族質感穿搭推薦｜既專業又有品味的辦公室穿搭",
    excerpt: "在職場上，穿著不只是個人風格的展現，更是專業形象的一部分。如何在保持優雅的同時，呈現出應有的專業感，是現代職場女性需要思考的課題。",
    readTime: "5 分鐘",
    date: "2024-03-22",
    image: "https://readdy.ai/api/search-image?query=elegant%20taiwanese%20mature%20professional%20woman%20office%20outfit%20blazer%20suit%20graceful%20urban%20warm%20cream%20beige%20background%20designer%20fashion%20quality%20editorial&width=1200&height=640&seq=blog004&orientation=landscape",
    tags: ["上班穿搭", "職場形象", "質感"],
    featured: false,
    content: [
      {
        heading: "辦公室穿搭的核心原則：精緻但不過分",
        body: "職場穿搭的最高境界是讓人記住你的氣質，而非你的衣服。選擇材質優良、剪裁精緻但設計低調的服飾，搭配得宜的配件，就能在職場中留下專業且有品味的印象。避免過於搶眼的印花或過多的裝飾，保持整體的簡潔感。",
        image: "https://readdy.ai/api/search-image?query=elegant%20professional%20taiwanese%20mature%20woman%20office%20style%20blazer%20trousers%20minimal%20clean%20warm%20neutral%20background%20designer%20quality%20fashion%20editorial%20photography&width=800&height=500&seq=blog004a&orientation=landscape"
      },
      {
        heading: "套裝的力量：一件好套裝可以走遍職場",
        body: "一套剪裁精良的套裝是職場女性最值得投資的服裝。選擇中性色調如米杏、深咖啡或霧灰色，可以搭配不同的內搭展現多種造型。外套單穿時可搭配輕鬆的內搭，整套穿著則立即呈現正式的專業形象，非常靈活。",
      },
      {
        heading: "細節決定品味：衣領與袖口的小心機",
        body: "在職場穿搭中，衣領設計和袖口細節往往是彰顯品味的關鍵。一個優雅的領結設計、一截精緻的袖口翻折，或是襯托膚色的 V 領設計，都能讓整體造型更為精緻有型。這些看似細微的設計，在日常工作中卻最容易被人注意到。",
      },
      {
        heading: "從辦公室到下班聚餐：一套穿兩種場合",
        body: "現代職場女性常常需要在下班後直接前往聚餐或約會，這時候選對服裝就非常重要。建議選擇可以透過配件改變場合感的服裝——例如一條質感洋裝，白天搭配西裝外套，下班後換上絲巾或珠寶項鍊，立刻從職場轉換為約會造型。",
        image: "https://readdy.ai/api/search-image?query=elegant%20taiwanese%20mature%20woman%20outfit%20transition%20office%20to%20evening%20event%20graceful%20sophisticated%20warm%20neutral%20background%20designer%20quality%20fashion%20editorial&width=800&height=500&seq=blog004b&orientation=landscape"
      }
    ],
  },
  {
    id: 5,
    category: "小個子穿搭",
    title: "小個子女性穿搭技巧｜輕鬆穿出顯高比例感",
    excerpt: "身高不夠高不代表無法穿出高挑感！掌握幾個關鍵的穿搭技巧，小個子女性同樣能穿出完美的身材比例和優雅氣質，讓每一天都充滿自信。",
    readTime: "4 分鐘",
    date: "2024-03-15",
    image: "https://readdy.ai/api/search-image?query=petite%20elegant%20taiwanese%20woman%20outfit%20vertical%20stripe%20high%20waist%20graceful%20fashion%20cream%20neutral%20background%20designer%20quality%20style%20editorial%20photography&width=1200&height=640&seq=blog005&orientation=landscape",
    tags: ["小個子", "顯高", "比例"],
    featured: false,
    content: [
      {
        heading: "高腰是小個子的最佳朋友",
        body: "高腰款式能將視覺腰線往上提，從視覺上拉長下半身的比例。高腰長褲配短版上衣，或高腰裙搭配塞入式上衣，都是小個子女性應該熟悉的穿搭公式。重點是讓腰線出現在實際腰部以上的位置。",
        image: "https://readdy.ai/api/search-image?query=petite%20elegant%20taiwanese%20woman%20high%20waist%20outfit%20graceful%20silhouette%20vertical%20proportion%20warm%20cream%20neutral%20background%20designer%20fashion%20quality%20editorial&width=800&height=500&seq=blog005a&orientation=landscape"
      },
      {
        heading: "同色調穿搭：最簡單的顯高公式",
        body: "上下身選擇同色或相近色調，能製造出視線不被截斷的連貫感，讓整體身形看起來更為修長。尤其是從鞋子到褲子都選擇同色調時，效果最為顯著。這是許多時尚編輯最推薦的小個子穿搭技巧。",
      },
      {
        heading: "裙子長度的選擇：避免截斷腿部線條",
        body: "對小個子女性來說，裙子長度的選擇格外重要。建議選擇迷你裙（大腿中段）或 Midi 長度（小腿中段），避免選擇剛好在膝蓋位置的裙擺，那個長度最容易讓腿部線條看起來更短。搭配同色系鞋子，讓腿部線條一路延伸。",
      }
    ],
  },
  {
    id: 6,
    category: "外套挑選",
    title: "換季外套挑選指南｜一件好外套讓穿搭質感倍增",
    excerpt: "外套是換季時節最重要的投資單品，一件剪裁精良、質感出色的外套，能讓任何簡單的內搭瞬間提升檔次，展現出品味與質感。這篇指南幫你找到最值得投資的外套款式。",
    readTime: "5 分鐘",
    date: "2024-03-08",
    image: "https://readdy.ai/api/search-image?query=elegant%20taiwanese%20mature%20woman%20coat%20jacket%20collection%20transitional%20season%20warm%20beige%20cream%20background%20designer%20fashion%20quality%20editorial%20photography&width=1200&height=640&seq=blog006&orientation=landscape",
    tags: ["外套", "換季", "質感"],
    featured: false,
    content: [
      {
        heading: "投資一件好外套的理由",
        body: "外套是整體造型中視覺佔比最大的單品，一件品質優良、剪裁精良的外套，能讓裡面即使是再簡單的搭配，都顯得有品味。相反的，一件廉價或版型不佳的外套，即使裡面穿著精緻，也會拉低整體的質感。因此，在服裝投資上，外套值得花更多預算。",
        image: "https://readdy.ai/api/search-image?query=elegant%20mature%20taiwanese%20woman%20quality%20coat%20blazer%20comparison%20well-tailored%20structured%20warm%20neutral%20cream%20background%20designer%20fashion%20editorial%20photography&width=800&height=500&seq=blog006a&orientation=landscape"
      },
      {
        heading: "長版外套：顯瘦顯高的神器",
        body: "長版外套（長度及大腿中段至膝蓋）是所有身材都適合的款式，縱向的視覺效果能同時達到顯瘦與顯高的效果。選擇有腰線設計或可以束腰帶的長版外套，效果更佳。深色的長版外套尤其適合想要修飾身材的女性。",
      },
      {
        heading: "西裝外套：職場到休閒皆適合",
        body: "一件經典的西裝外套是衣橱中最萬用的投資單品。從正式的職場場合，到搭配牛仔褲的休閒日常，西裝外套都能輕鬆駕馭。選擇剪裁俐落、材質挺括的款式，注意肩線的合身度，那是西裝外套穿起來是否好看的關鍵。",
        image: "https://readdy.ai/api/search-image?query=elegant%20mature%20taiwanese%20woman%20blazer%20jacket%20versatile%20styling%20office%20casual%20warm%20neutral%20background%20taiwanese%20designer%20quality%20fabric%20fashion%20editorial&width=800&height=500&seq=blog006b&orientation=landscape"
      },
      {
        heading: "面料的選擇：質感的核心",
        body: "外套的面料直接決定了穿著的質感。羊毛或羊毛混紡是最值得投資的面料，挺括有型、保暖性佳且耐穿。精紡毛料的外套穿起來有一種天然的優雅感，這是化纖面料無法複製的。如果預算有限，可以選擇高品質的聚酯纖維混紡，只要剪裁到位，同樣能呈現出不俗的質感。",
      }
    ],
  },
];

export const blogCategories = ["全部文章","熟齡穿搭","顯瘦技巧","洋裝挑選","上班穿搭","小個子穿搭","外套挑選"];
